import { render } from "./Download.vue?vue&type=template&id=2256c180"
const script = {}

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c888307087c990cfda5c0d18ef320e2e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/icons/Download.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2256c180"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2256c180', __exports__)) {
    api.reload('2256c180', __exports__)
  }
  
  module.hot.accept("./Download.vue?vue&type=template&id=2256c180", () => {
    api.rerender('2256c180', render)
  })

}


export default __exports__